import { render, staticRenderFns } from "./ProductPPLdata.vue?vue&type=template&id=3d4b1555&"
import script from "./ProductPPLdata.vue?vue&type=script&lang=js&"
export * from "./ProductPPLdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports